import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { ReadOnlyProps } from "../Project/EditProject/ReadOnlyProps";

type Props = {
  openingTimeId: number;
  deleteOpeningTime: () => void;
  changeEditMode: () => void;
  isNewlyAddedOpeningTime: boolean;
  clearNewlyAddedOpeningTimes: () => void;
};

export const ActionButtonsNotInEditMode = ({
  openingTimeId,
  deleteOpeningTime,
  changeEditMode,
  isNewlyAddedOpeningTime,
  clearNewlyAddedOpeningTimes,
  isReadOnly,
}: Props & ReadOnlyProps) => {
  return (
    <>
      {/* Switch to edit mode icon */}
      <IconButton
        key={`edit_${openingTimeId}`}
        type="button"
        onClick={() => changeEditMode()}
        disabled={isReadOnly}
      >
        <EditIcon />
      </IconButton>

      {/* Cancel creation of new opening time */}
      {isNewlyAddedOpeningTime && (
        <IconButton
          key={`delete_${openingTimeId}`}
          type="button"
          onClick={() => clearNewlyAddedOpeningTimes()}
        >
          <DeleteForeverIcon />
        </IconButton>
      )}

      {!isNewlyAddedOpeningTime && (
        <IconButton
          onClick={async (e) => {
            e.stopPropagation();
            deleteOpeningTime();
          }}
          disabled={isReadOnly}
        >
          <DeleteIcon type="button" key="delete" />
        </IconButton>
      )}
    </>
  );
};
